import { LayoutMode, LayoutProps } from 'components/types';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectStringTranslator } from 'state/ducks/translator-strings/slice';
import { selectSubscriptionStatusByStateCode } from 'state/ducks/waitlist-subscription';
import { getWaitlistSubscriptionStatusSaga, subscribeToWaitlistSaga } from 'state/ducks/waitlist-subscription/sagas';
import { useAppSelector } from 'state/hooks';
import InitialContext from 'state/static-data/InitialContext';
import { StateEntity, SubscribeToWaitlistSagaRequest, WaitlistSubscriptionStatus } from 'state/types';
import { TranslatorStringIds } from 'utils';

export interface StateWaitlistWidgetProps extends LayoutProps {
    readonly selectedState: StateEntity
}
const StateWaitlistWidget = ({ selectedState, layoutMode }: StateWaitlistWidgetProps) => {
    const t = useSelector(selectStringTranslator);
    const dispatch = useDispatch();

    const waitlistSubscriptionStatus = useAppSelector(state => selectSubscriptionStatusByStateCode(state, selectedState.stateCode))
    useEffect(() => {
        if (layoutMode == LayoutMode.DESKTOP && !selectedState.launched && !waitlistSubscriptionStatus) {
            dispatch(getWaitlistSubscriptionStatusSaga(selectedState.stateCode))
        }
    });

    const onAddWaitlistButtonClick = () => {
        const request: SubscribeToWaitlistSagaRequest = {
            asin: InitialContext.getRequestAsin(),
            stateCode: selectedState.stateCode
        }
        dispatch(subscribeToWaitlistSaga(request))
    }

    if (selectedState.launched) {
        // do nothing if state already launched
        return (<></>)
    }
    return (
        <>
            <pui-section flowDirection="horizontal" secondaryAxisArrangement="start">
                <pui-icon imgClass="status-error-icon" spacingRight="mini" />
                <pui-text input={t.resolve(TranslatorStringIds.ChooseYourStateJoinWaitlistDescription_Template, { location: selectedState.label })} encode />
            </pui-section>
            {
                waitlistSubscriptionStatus?.status !== WaitlistSubscriptionStatus.ACTIVE &&
                <pui-button
                    spacingTop="medium"
                    label={t.resolve(TranslatorStringIds.ChooseYourStateJoinWaitlistButton)}
                    textSize="large"
                    onClick={onAddWaitlistButtonClick}
                ></pui-button>
            }
            {
                waitlistSubscriptionStatus?.status === WaitlistSubscriptionStatus.ACTIVE &&
                <pui-box class="state-waitlist-success-message pui-box-solid" spacingTop="medium" flowDirection="vertical">
                    <pui-section flowDirection="horizontal" class="state-waitlist-message-title"
                        secondaryAxisArrangement="start">
                        <pui-icon imgClass="status-info-icon" spacingRight="mini" />
                        <pui-text fontWeight="bold" input={t.resolve(TranslatorStringIds.ChooseYourStateJoinWaitlistAddedHeader)} encode></pui-text>
                    </pui-section>

                    <pui-section flowDirection="horizontal" spacingTop="mini" class="state-waitlist-message-description"
                        secondaryAxisArrangement="start">
                        <pui-icon imgClass="" />
                        <pui-text spacingLeft="medium" input={t.resolve(TranslatorStringIds.ChooseYourStateJoinWaitlistAddedDescription_Template, { location: selectedState.label })} encode />
                    </pui-section>
                </pui-box>
            }
        </>
    )
}
export default StateWaitlistWidget;